export default __webpack_public_path__ + "static/media/notification.0c9a9b42.svg";